const ProjectTags = ({ tags }) => {

    return tags.map((tag) => (
        <span key={tag} className="project-tag">
            {tag}
        </span>
    ))
}

export default ProjectTags;